export const UNIFIED_LOGIN_PATH = "/naturals/login";
export const EXECUTIVE_LOGIN_PATH = "/naturals/executive";
export const WORKSPACE_LOGIN_PATH = "/naturals/workspace";
export const PARTNER_LOGIN_PATH = "/naturals/partner";
export const ACTIVATE_BASE_PATH = "/naturals/activate";
export const THIS_LOGIN_PATH = UNIFIED_LOGIN_PATH;

export const SUPER_ADMIN_LOGIN_PATH = EXECUTIVE_LOGIN_PATH;
export const HQ_ADMIN_LOGIN_PATH = WORKSPACE_LOGIN_PATH;
export const FRANCHISE_LOGIN_PATH = PARTNER_LOGIN_PATH;

export function loginPathForRole(role) {
  if (role == null || String(role).trim() === "") {
    return THIS_LOGIN_PATH;
  }
  return loginPathForAudience(role);
}

export function loginPathForAudience(audience) {
  return UNIFIED_LOGIN_PATH;
}

export function audienceLabel(audience) {
  const a = String(audience || "admin").toLowerCase();
  if (a === "super_admin" || a === "super-admin" || a === "executive") return "Executive";
  if (a === "partner" || a === "franchise" || a === "user" || a === "franchise_admin") {
    return "Partner";
  }
  return "Workspace";
}

export function loginHeading(audience) {
  return `Sign in to ${audienceLabel(audience)}`;
}

export function setPasswordPath(token) {
  return `${ACTIVATE_BASE_PATH}/set-password/${token || ""}`;
}
